import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorImageLayer from 'ol/layer/VectorImage';
import TileSource from 'ol/source/TileWMS';
import VectorSource from 'ol/source/Vector';
import { Style, Icon, Fill, Stroke, Text, Circle } from 'ol/style';
import ImageWMS from 'ol/source/ImageWMS';
import ImageLayer from 'ol/layer/Image';
import OSM from 'ol/source/OSM';
import WKT from 'ol/format/WKT';
import GeoJson from 'ol/format/GeoJSON';
import { MousePosition, OverviewMap } from "ol/control";
import { pointerMove, click } from "ol/events/condition";
import { OlDefault } from './OlDefault';
import { XYZ, BingMaps } from 'ol/source';
import { METERS_PER_UNIT } from 'ol/proj';
import ContextMenu from 'ol-contextmenu';
import { Draw, Modify, Snap, DoubleClickZoom, Select } from "ol/interaction";
import { transform } from 'ol/proj';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import * as olCoordinate from 'ol/coordinate';
import { createXYZ } from 'ol/tilegrid';
import { get as getProjection2 } from 'ol/proj.js';
import { getWidth, getTopLeft } from 'ol/extent.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import proj4 from "proj4";
import { register } from 'ol/proj/proj4.js';
import { transformExtent } from "ol/proj";
import TileState from 'ol/TileState';
import "ol-contextmenu/dist/ol-contextmenu.css";
import centerIcon from "../../public/center.png";
import clearIcon from "../../public/clear.png";
import copyIcon from "../../public/copy.png";
import panIcon from "../../public/pan.png";
import infoIcon from "../../public/circle-info.png";
import navIcon from "../../public/nav.png";
import googleMapIcon from "../../public/googleMap.png";
import yandexMapIcon from "../../public/yandexMap.png";
import Overlay from 'ol/Overlay';
import * as turf from '@turf/turf';
import CircleStyle from 'ol/style/Circle';
import { MultiPolygon, Polygon } from 'ol/geom';
import CustomSelect from '../interactions/CustomSelect';
import RotateFeatureInteraction from 'ol-rotate-feature';
import CustomTranslate from '../interactions/CustomTranslate';
import Geolocation from 'ol/Geolocation.js';
import Collection from 'ol/Collection';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import { Control, defaults as defaultControls } from 'ol/control.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import otherTool from './otherTool';
import Crop from 'ol-ext/filter/Crop';
import KML from 'ol/format/KML';
import RegularShape from 'ol/style/RegularShape.js';

proj4.defs('EPSG:3395', '+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs');
register(proj4);

export class MapTool {

    map;

    mapProjection;

    wktProjection;

    mapShouldUpdate = false;

    mapStateForwardList = [];

    mapStatePreviousList = [];

    firstView;

    mouseControlProjection;

    mouseControlOutput = 'E: {y} | B: {x}';

    activeLayer = [];

    infoWindowFunc;

    selectDrawFunc;

    glbSelectedBaseMap = "";

    lclSelectedBaseMap = "";

    selectCombinePolygonFunc;

    unSelectModifyFunc;

    removeSelectingDrawFunc;

    selectEntoEndFirstObjectFunc;

    selectEntoEndSecondObjectFunc;

    takeParallelFunc;

    geolocation = new Geolocation({
        trackingOptions: {
            enableHighAccuracy: true,
        },
        projection: "EPSG:3857",
        name: 'geolocationProp',
    });

    constructor(mouseControlProjection) {
        this.mouseControlProjection = mouseControlProjection ?? "EPSG:4326";
    }

    contextMenuItems = [
        {
            value: "CLEAR",
            text: "Haritayı Temizle",
            classname: 'bold',
            callback: () => {
                // if (document.getElementById("drawMeasure") !== null) {

                //     document.querySelectorAll(".ol-overlay-container.ol-selectable").forEach((data) => { data.remove() });
                // }

                this.clearMap();
            },
            icon: clearIcon,

        },
        {
            value: "COPY",
            text: "Koordinatı Kopyala",
            callback: (data) => {

                if (this.mouseControlProjection !== "EPSG:4326") {

                    let coordinate = [data.coordinate[0], data.coordinate[1]];

                    let templateOne = '{x} {y}';

                    let finalCoord = olCoordinate.format(
                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateOne,
                        2);

                    navigator.clipboard.writeText(finalCoord);
                }
                else {

                    let coordinate = [data.coordinate[0], data.coordinate[1]];

                    let templateTwo = '{y} {x}';

                    let finalCoord = olCoordinate.format(
                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateTwo,
                        6);

                    navigator.clipboard.writeText(finalCoord);
                }
            },
            icon: copyIcon
        },
        {
            value: "CENTER",
            text: "Ortala",
            classname: 'bold',
            callback: function (data, e) {

                var view = e.getView();

                view.animate({
                    zoom: view.getZoom(),
                    duration: 700,
                    center: data.coordinate
                });
            },
            icon: centerIcon
        },
        {
            value: "PAN",
            text: "Pan",
            classname: "bold",
            callback: () => { this.pan(); },
            icon: panIcon
        },
        {
            value: "GETINFO",
            text: "Bilgi Al",
            classname: "bold",
            callback: (obj, e) => {
                if (this.infoWindowFunc) {
                    this.infoWindowFunc(obj, e);
                }
                // this.clearLayersByName(["info-layer"]);
                // this.enableInteraction("info-interaction");
            },
            icon: infoIcon
        },
        {
            value: "NAVIGATE",
            text: "Navigasyona Git",
            items: [
                {
                    icon: googleMapIcon,
                    text: 'Google Haritalar',
                    callback: (data) => {
                        this.geolocation.setProjection(this.getProjection());
                        let pos;
                        this.geolocation.setTracking(true);
                        setTimeout(() => {
                            pos = this.geolocation.getPosition();
                            let googleMapsUrl = 'https://www.google.com/maps/dir/';
                            if (pos && pos.length > 0) {
                                let wkt = "POINT(" + pos[0] + " " + pos[1] + ")";
                                let feat = MapTool.convertToFeature(wkt, this.mapProjection, 'EPSG:4326');
                                let coords = feat.getGeometry().getCoordinates();


                                if (this.mouseControlProjection !== "EPSG:4326") {
                                    let coordinate = [data.coordinate[0], data.coordinate[1]]
                                    let templateOne = '{x} {y}';
                                    let finalCoord = olCoordinate.format(
                                        proj4(this.mapProjection, this.mouseControlProjection, coordinate), templateOne,
                                        2);
                                    let _x = finalCoord.split(" ")[1];
                                    let _y = finalCoord.split(" ")[0];
                                    let gUrl = googleMapsUrl + coords[1] + "," + coords[0] + "/" + _x + "," + _y;
                                    window.open(gUrl);
                                }
                                else {

                                    let coordinate = [data.coordinate[0], data.coordinate[1]]
                                    let templateTwo = '{y} {x}';
                                    let finalCoord = olCoordinate.format(
                                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateTwo,
                                        6);
                                    let _x = finalCoord.split(" ")[0];
                                    let _y = finalCoord.split(" ")[1];
                                    let gUrl = googleMapsUrl + coords[1] + "," + coords[0] + "/" + _x + "," + _y;

                                    window.open(gUrl);
                                }
                            }
                            else {
                                //alert("Konum Bulma Kapalı: Tarayıcınızdan konum izni verip tekrar deneyiniz.")   

                                if (this.mouseControlProjection !== "EPSG:4326") {
                                    let coordinate = [data.coordinate[0], data.coordinate[1]]
                                    let templateOne = '{x} {y}';
                                    let finalCoord = olCoordinate.format(
                                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateOne,
                                        2);
                                    let _x = finalCoord.split(" ")[1];
                                    let _y = finalCoord.split(" ")[0];
                                    let gUrl = googleMapsUrl + "/" + _x + "," + _y;
                                    window.open(gUrl);
                                }
                                else {

                                    let coordinate = [data.coordinate[0], data.coordinate[1]]
                                    let templateTwo = '{y} {x}';
                                    let finalCoord = olCoordinate.format(
                                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateTwo,
                                        6);
                                    let _x = finalCoord.split(" ")[0];
                                    let _y = finalCoord.split(" ")[1];
                                    let gUrl = googleMapsUrl + "/" + _x + "," + _y;

                                    window.open(gUrl);
                                }
                            }

                        }, 1000);

                    },
                },
                {
                    icon: yandexMapIcon,
                    text: 'Yandex Harita',
                    callback: (data) => {
                        this.geolocation.setProjection(this.getProjection());
                        let pos;
                        this.geolocation.setTracking(true);
                        setTimeout(() => {
                            pos = this.geolocation.getPosition();
                            let yandexMapsUrl = 'https://yandex.com.tr/harita/?&mode=routes&rtext=';

                            if (pos && pos.length > 0) {
                                let wkt = "POINT(" + pos[0] + " " + pos[1] + ")";
                                let feat = MapTool.convertToFeature(wkt, this.mapProjection, 'EPSG:4326');
                                let coords = feat.getGeometry().getCoordinates();


                                if (this.mouseControlProjection !== "EPSG:4326") {

                                    let coordinate = [data.coordinate[0], data.coordinate[1]]

                                    let templateOne = '{x} {y}';

                                    let finalCoord = olCoordinate.format(
                                        proj4(this.mapProjection, this.mouseControlProjection, coordinate), templateOne,
                                        2);
                                    let _x = finalCoord.split(" ")[1];
                                    let _y = finalCoord.split(" ")[0];
                                    let yUrl = yandexMapsUrl + _x + "," + _y + "~" + coords[0] + "," + coords[1] + "&rtt=auto";
                                    window.open(yUrl);
                                }
                                else {

                                    let coordinate = [data.coordinate[0], data.coordinate[1]];
                                    let templateTwo = '{y} {x}';
                                    let finalCoord = olCoordinate.format(
                                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateTwo,
                                        6);
                                    let _x = finalCoord.split(" ")[0];
                                    let _y = finalCoord.split(" ")[1];
                                    let yUrl = yandexMapsUrl + _x + "," + _y + "~" + coords[1] + "," + coords[0] + "&rtt=auto";
                                    window.open(yUrl);
                                }
                            }
                            else {
                                if (this.mouseControlProjection !== "EPSG:4326") {

                                    let coordinate = [data.coordinate[0], data.coordinate[1]]

                                    let templateOne = '{x} {y}';

                                    let finalCoord = olCoordinate.format(
                                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateOne,
                                        2);
                                    let _x = finalCoord.split(" ")[1];
                                    let _y = finalCoord.split(" ")[0];
                                    let yUrl = yandexMapsUrl + _x + "," + _y + "&rtt=auto";
                                    window.open(yUrl);
                                }
                                else {

                                    let coordinate = [data.coordinate[0], data.coordinate[1]];
                                    let templateTwo = '{y} {x}';
                                    let finalCoord = olCoordinate.format(
                                        proj4('EPSG:3857', this.mouseControlProjection, coordinate), templateTwo,
                                        6);
                                    let _x = finalCoord.split(" ")[0];
                                    let _y = finalCoord.split(" ")[1];
                                    let yUrl = yandexMapsUrl + _x + "," + _y + "&rtt=auto";
                                    window.open(yUrl);
                                }
                            }
                        }, 1000);
                    },
                },
            ],
            icon: navIcon
        },
    ];
    setInfoWindowFunc = (func) => {
        if (func) {
            this.infoWindowFunc = func;
        }
    }
    getInfoWindowFunc = () => {
        return this.infoWindowFunc;
    }
    setBingKey = (bingKey) => {
        const bingMaps = [
            {
                id: 'BR',
                source: MapTool.createBingSource({
                    crossOrigin: 'Anonymous',
                    imagerySet: 'Road',
                    key: bingKey
                })
            },
            {
                id: 'BS',
                source: MapTool.createBingSource({
                    crossOrigin: 'Anonymous',
                    imagerySet: 'Aerial',
                    key: bingKey
                })
            },
            {
                id: 'BP',
                source: MapTool.createBingSource({
                    crossOrigin: 'Anonymous',
                    imagerySet: 'AerialWithLabels',
                    key: bingKey
                })
            }];

        baseMaps = [...baseMaps, ...bingMaps];
    }

    setGoogleKey = (googleKey) => {

        const googleMaps = [{
            id: 'GR',
            source: MapTool.createOsmSource({
                crossOrigin: 'Anonymous',
                url: 'https://mts{0-3}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=s.t:2%7Cs.e:l%7Cp.v:off,s.t:20%7Cs.e:l%7Cp.v:off' +
                    (googleKey ? "&key=" + googleKey : "")
            })
        },
        {
            id: 'GST',
            source: MapTool.createOsmSource({
                crossOrigin: 'Anonymous',
                url: 'https://mts{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&apistyle=s.t:0%7Cs.e:l%7Cp.v:off,s.t:20%7Cs.e:l%7Cp.v:off' +
                    (googleKey ? "&key=" + googleKey : "")
            })
        },
        {
            id: 'GS',
            source: MapTool.createOsmSource({
                crossOrigin: 'Anonymous',
                url: 'https://mts{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}' +
                    (googleKey ? "&key=" + googleKey : "")
            })
        },
        {
            id: 'GP',
            source: MapTool.createOsmSource({
                crossOrigin: 'Anonymous',
                url: 'https://mts{0-3}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}' +
                    (googleKey ? "&key=" + googleKey : "")
            })
        }];

        baseMaps = [...baseMaps, ...googleMaps];
    }

    setYandexKey = (yandexKey) => {

        const yandexMaps = [{
            id: 'YR',
            source: new XYZ({
                url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=21.11.09-0-b211103130830&x={x}&y={y}&z={z}&scale=1&lang=tr_TR' +
                    (yandexKey ? "&key=" + yandexKey : ""),
                projection: 'EPSG:3395',
                crossOrigin: 'Anonymous',
                tileGrid: createXYZ({
                    extent: [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244],
                    tileSize: 512
                }),
                transition: 0
            })
        },
        {
            id: 'YU',
            source: new XYZ({
                url: 'https://sat01.maps.yandex.net/tiles?l=sat&v=3.249.0&x={x}&y={y}&z={z}&lang=tr_TR' +
                    (yandexKey ? "&key=" + yandexKey : ""),
                projection: 'EPSG:3395',
                crossOrigin: 'Anonymous',
                tileGrid: createXYZ({
                    extent: [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244],
                    tileSize: 512
                }),
                transition: 0
            })
        }];

        baseMaps = [...baseMaps, ...yandexMaps];
    }

    setBmsKey = (bmsKey) => {

        const bmsMaps = [
            {
                id: 'BMS',
                source: MapTool.createOsmSource({
                    crossOrigin: 'Anonymous',
                    url: `https://bms.basarsoft.com.tr/service/api/v1/map/Default?appcode=${bmsKey.appCode}&accid=${bmsKey.accId}&z={z}&x={x}&y={y}`
                })
            }];

        baseMaps = [...baseMaps, ...bmsMaps];
    }

    setExtraMaps = (maps) => {

        baseMaps = [...baseMaps, ...maps.map(x => {

            return {
                id: x.value,
                source: x.source
            }
        })];
    }

    setMouseControlProjection = (projection) => this.mouseControlProjection = projection;

    getMouseControlProjection = () => this.mouseControlProjection;

    setMouseControlOutput = (output) => this.mouseControlOutput = output;

    getMouseControlOutput = () => this.mouseControlOutput;

    getMap = () => this.map;

    getContextMenu = (defaultItems, extraItems) => {

        let contextmenu = new ContextMenu({
            width: 180,
            items: [...this.contextMenuItems, ...extraItems],
            defaultItems: defaultItems
        });

        return contextmenu;

    };

    createMap = (options) => {

        const opts = { ...OlDefault.olMap, ...OlDefault.olOptions, ...options };

        this.firstView = { ...OlDefault.olView, ...opts.view };

        const controls = [];

        if (opts.hasMouseControl) {

            controls.push(this.getMouseControl());
        }

        if (opts.hasContextMenu) {

            let defaultItems = false

            if (!opts.contextMenuItems || opts.contextMenuItems.includes("ZOOM")) {

                defaultItems = true;
            }

            if (opts.contextMenuItems) {

                this.contextMenuItems = this.contextMenuItems.
                    filter(x => opts.contextMenuItems.includes(x.value));
            }
            if (opts.extraMenuNavigationItems) {
                opts.extraMenuNavigationItems.forEach(item => {
                    const navigateItem = this.contextMenuItems.find(menuItem => menuItem.value === "NAVIGATE");
                    if (navigateItem) {
                        navigateItem.items.push(item);
                    }
                });
            }

            controls.push(this.getContextMenu(defaultItems, opts.extraMenuItems ?? [], opts.extraMenuNavigationItems ?? []));
        }

        this.mapProjection = this.firstView.projection;

        const span5 = document.createElement('span');
        span5.style.display = 'flex';
        span5.style.color = 'var(--bs-color)'
        span5.title = 'Kuzey';
        span5.id = 'rotate-icon'
        span5.innerHTML = '<i class="pi pi-send custom-nav-icon"></i>';



        this.map = new Map({
            pixelRatio: 1,
            view: MapTool.createView(this.firstView),
            layers: opts.layers,
            target: opts.id,
            controls: defaultControls({
                rotateOptions: { label: span5 }
            })

        });

        controls.map((x) => this.map.addControl(x));


        window.Object.map = this.map;

        return this.map;
    }

    refreshWmsLayerForDynamicForm = () => {

        const layers = this.getMap().getLayers().getArray().filter(x => x.get('name').includes('wms-layer-'));

        for (const layer of layers) {

            const params = layer.getSource().getParams();

            params.t = new Date().getMilliseconds();

            layer.getSource().updateParams(params);
        }


    }

    findSnappedFeature = (coordinates) => {

        let features = [];

        this.getMap().getLayers().getArray().filter(x => x instanceof VectorLayer || x instanceof VectorImageLayer).forEach((layer) => {
            if (layer) {
                if (layer.getSource().getFeatures().length > 0) {
                    for (let index = 0; index < layer.getSource().getFeatures().length; index++) {
                        const element = layer.getSource().getFeatures()[index];
                        features.push(element);
                    }
                }
            }
        });

        for (let i = 0; i < features.length; i++) {
            let feature = features[i];
            if (feature.getGeometry().intersectsCoordinate(coordinates)) {
                return feature;
            }
        }

        return null;
    }

    addFeature = (layer, feature) => {

        const source = this.getLayerSource(layer);

        source.addFeature(feature);
    }

    setActiveLayer = (data) => {
        this.activeLayer = data;
    }

    getActiveLayer = () => {
        return this.activeLayer;
    }

    static createView = (options) => {

        return new View({
            center: options.center,
            projection: options.projection,
            rotation: options.rotation,
            maxZoom: 26,
            zoom: options.zoom,
            extent: options.extent
        });
    }

    getCrop = (feature) => {
        return new Crop({
            feature: feature,
            wrapX: true,
            inner: false
        });
    }

    static getFeatureInMapActive = (activeLayer, workspaceId, mapTool) => {
        let obj;

        let values = [];


        let activeLayers = this.getLayerSource(mapTool, activeLayer);

        let featureArray = activeLayers.getFeatures();

        if (featureArray.length >= 0) {
            featureArray.map((value, index) => {
                let valueProp = value.getProperties();  // feature içerisine setlediğimiz değerleri object olarak getirmektedir.

                delete valueProp["geometry"];  // Geometry alanı gereksiz olduğu için object array içerisinden kaldırılmıştır.

                let setValue = JSON.stringify(valueProp);

                let type = value.getGeometry().getType();

                let wkt = MapTool.convertToWkt(value, this.wktProjection, this.mapProjection); // içerisine aldığı geometry değerini string wkt ye dönüştürmektedir.

                obj = ({
                    workspaceId: parseFloat(workspaceId),
                    type: type,
                    wkt: wkt,
                    value: setValue
                });

                values.push(obj);
            })

            return values;
        }
    }

    static createXyzSource = (options) => {

        let opts = { ...OlDefault.olXyzSource, ...options };

        return new XYZ({
            url: opts.url,
            crossOrigin: opts.crossOrigin
        });
    }

    static createBingSource = (options) => {

        let opts = { ...OlDefault.olBingSource, ...options };

        return new BingMaps({
            crossOrigin: opts.crossOrigin,
            key: opts.key,
            imagerySet: opts.imagerySet
        });
    }

    static createOsmSource = (options) => {

        let opts = { ...OlDefault.olOsmSource, ...options };

        return new OSM({
            url: opts.url,
            crossOrigin: opts.crossOrigin,
            attributions: null
        });
    }

    addLayer = (layer) => this.map.addLayer(layer);

    addLayers = (layers) => {

        for (let i = 0; i < layers.length; i++) {

            this.addLayer(layers[i]);
        }
    }

    mapBack = () => {

        if (this.mapStatePreviousList.length <= 1) {
            return;
        }

        let popElement = this.mapStatePreviousList.pop();

        this.mapStateForwardList.push(popElement);

        let mapState = this.mapStatePreviousList[this.mapStatePreviousList.length - 1];

        if (!mapState) {
            return;
        }

        this.setCenterPoint({ centerPoint: mapState.centerPoint });

        this.setRotationDegree({ rotationDegree: mapState.rotationDegree });

        this.setScale({ scaleValue: mapState.scaleValue });

        this.mapShouldUpdate = false;
    }

    getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    getNetworkAnalysisStyle = (type, color, isDashed = false) => {
        if (type === 'Point') {
            return new Style({
                image: new Circle({
                    radius: 10,
                    fill: new Fill({ color: 'rgba(255, 0, 0, 0.1)' }),
                    stroke: new Stroke({ color: color, width: 1 }),
                }),
            });
        } else {
            return new Style({
                stroke: new Stroke({
                    color: color,
                    width: 3,
                    lineDash: isDashed ? [10, 10] : undefined, // Kesikli çizgi kontrolü
                }),
                fill: new Fill({
                    color: color,
                }),
            });
        }
    };

    getInfoStyle = (type, color, isDashed = false) => {
        const makeTransparent = (color, opacity) => {
            if (color.startsWith('#')) {
                const hex = color.replace('#', '');
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);
                return `rgba(${r}, ${g}, ${b}, ${opacity})`;
            } else if (color.startsWith('rgb') && !color.includes('a')) {
                return color.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
            } else if (color.startsWith('rgba')) {
                return color.replace(/, [0-9.]+\)/, `, ${opacity})`);
            }
            return color;
        };

        const transparentColor = makeTransparent(color, 0.3); // %30 saydamlık

        if (type === 'Point') {
            return new Style({
                image: new Circle({
                    radius: 10,
                    stroke: new Stroke({ color: color, width: 1 }),
                }),
            });
        } else {
            return new Style({
                stroke: new Stroke({
                    color: color,
                    width: 3,
                    lineDash: isDashed ? [10, 10] : undefined,
                }),
                fill: new Fill({
                    color: transparentColor,
                }),
            });
        }
    };



    getNetworkAnalysisRandomStyle = (type) => {
        const randomColor = this.getRandomColor(); // 
        if (type === 'Point') {
            return new Style({
                image: new Circle({
                    radius: 10,
                    fill: new Fill({ color: `rgba(${parseInt(randomColor.slice(1, 3), 16)}, ${parseInt(randomColor.slice(3, 5), 16)}, ${parseInt(randomColor.slice(5, 7), 16)}, 0.1)` }),
                    stroke: new Stroke({ color: randomColor, width: 1 }),
                }),
            });
        } else {
            return new Style({
                stroke: new Stroke({
                    color: randomColor,
                    width: 3,
                }),
                fill: new Fill({
                    color: `rgba(${parseInt(randomColor.slice(1, 3), 16)}, ${parseInt(randomColor.slice(3, 5), 16)}, ${parseInt(randomColor.slice(5, 7), 16)}, 0.1)`,
                }),
            });
        }
    };
    mapForward = () => {

        if (this.mapStateForwardList.length <= 0) {

            return;
        }

        let mapState = this.mapStateForwardList.pop()

        if (!mapState) {

            return;
        }

        this.mapStatePreviousList.push(mapState);

        this.setCenterPoint({ centerPoint: mapState.centerPoint });

        this.setRotationDegree({ rotationDegree: mapState.rotationDegree });

        this.setScale({ scaleValue: mapState.scaleValue });

        this.mapShouldUpdate = false;
    }

    updatePermalink = () => {

        if (!this.mapShouldUpdate) {

            this.mapShouldUpdate = true;

            return;
        }

        let state = {
            scaleValue: this.getScale(),
            centerPoint: this.getCenterPoint(),
            rotationDegree: this.getRotationDegree({})
        };

        if (this.mapStatePreviousList.some(x => x.scaleValue === state.scaleValue)) {
            return;
        }

        this.mapStatePreviousList.push(state);

        this.mapStateForwardList = [];
    }

    getProjection = () => this.getView().getProjection();

    getScale = () =>
        this.getResolution() * METERS_PER_UNIT[this.getProjection().getUnits()] *
        39.37 * (25.4 / 0.28);

    setScale = (options) => {

        let opts = { ...OlDefault.olScale, ...options };

        this.setResolution({
            resolutionValue:
                (opts.scaleValue / (METERS_PER_UNIT[this.getProjection().getUnits()] *
                    39.37 * (25.4 / 0.28)))
        });
    }

    getResolution = () => this.getView().getResolution();

    setResolution = (options) => {

        let opts = { ...OlDefault.olResolution, ...options };

        this.getView().setResolution(opts.resolutionValue);
    }

    getView = () => this.map.getView();

    getRotationDegree = () => this.getView().getRotation();

    setRotationDegree = (options) => {

        let opts = { ...OlDefault.olRotation, ...options };

        this.getView().setRotation(opts.rotationDegree);
    }

    getCenterPoint = () => this.getView().getCenter();

    setCenterPoint = (options) => {

        let opts = { ...OlDefault.olCenter, ...options };

        this.getView().setCenter(opts.centerPoint);
    }

    setMoveEnd = (action) => this.map.on("moveend", action);

    resetMap = (layerName) => {

        if (layerName) {

            const layer = findLayer(layerName);

            const feature = layer.getSource().getFeatures()[0];

            this.viewLayerExtent(layerName, feature);

        } else {

            this.setCenterPoint({ centerPoint: this.firstView.center });

            this.setZoomLevel({ zoomLevel: this.firstView.zoom });
        }
    }

    setZoomLevel = (options) => {

        let opts = { ...OlDefault.olZoom, ...options };

        this.getView().setZoom(opts.zoomLevel);
    }

    getMapVectorLayers = () => {

        const vectorLayers = this.map.getLayers().getArray().filter((x) => x.get("name").includes("wfs-layer"));

        return vectorLayers;
    }

    addInteraction = (interaction) => this.map.addInteraction(interaction);

    createDrawInteraction = (name, layer, type) => {

        const source = this.getLayerSource(layer);

        const interaction = new Draw({
            type: type.toString(),
            source: source,
        });

        interaction.set("name", name);

        interaction.setActive(false);

        return interaction;
    }

    selectLineStyle = (new Style({
        fill: new Fill({
            color: '#3d85c6',
        }),
        stroke: new Stroke({
            color: 'rgba(255, 0, 0)',
            width: 3,
        }),
    }));

    selectHoverStyle = (new Style({
        fill: new Fill({
            color: 'rgba(143, 206, 0, 0.1)',
        }),
        stroke: new Stroke({
            color: 'rgba(255, 0, 0)',
            width: 3,
        }),
    }));

    selectPointHoverStyle = (new Style({
        image: new Circle({
            fill: new Fill({
                color: 'rgba(143, 206, 0, 0.1)'
            }),
            radius: 10,
            stroke: new Stroke({
                color: 'rgba(255, 0, 0)',
                width: 1
            })
        })
    }));

    getLayersFeatures = (layers) => {

        var snapCollection = new Collection([], {
            unique: true
        });

        for (var i = 0; i < layers.length; i++) {
            let featureList = layers[i].getSource().getFeatures();
            featureList.forEach((feature) => {
                snapCollection.push(feature);
            });
        }

        return snapCollection;
    };

    getSelectInteractionFeatures = (name) => {

        const interaction = this.getInteraction(name);

        let _feats = interaction.getFeatures();
        return _feats;

    };

    createModifyInteraction = (name, layer, features) => {

        if (features !== undefined) {

            const interaction = new Modify({
                features: features,
            });

            interaction.set("name", name);

            return interaction;
        }
        else {

            const source = this.getLayerSource(layer);

            const interaction = new Modify({
                source: source,
            });

            interaction.set("name", name);

            return interaction;
        }
    };

    createHoverCondition = () => {

        return pointerMove;

    }

    createClickCondition = () => {

        return click;

    }

    createSnap = (name, layerName, features) => {


        let interaction = new Snap();

        if (features) {

            if (features.array_.length == 0) {

                return;
            }
            var snapCollection = new Collection([], {
                unique: true
            });
            features.forEach(element => {
                snapCollection.push(element);
            });

            interaction = new Snap({
                features: features
            });
        }
        else {
            let layerSource = this.getLayerSource(layerName);

            if (!layerSource) {
                return;
            }
            interaction = new Snap({
                source: layerSource
            });
        }


        interaction.set("name", name);

        interaction.setActive(false);

        this.addInteraction(interaction);
    }

    createSnapWithHitTolerance = (source, snapHitTolerance) => {

        return new Snap({
            source: source,
            pixelTolerance: snapHitTolerance
        });

    }

    enableSnap = (status, name) => {
        let interaction = this.getInteraction(name);

        if (!interaction) {
            return;
        }

        let snapInteractions = this.map
            .getInteractions()
            .getArray()
            .filter(x => x instanceof Snap && x.get("name") === name);

        snapInteractions.forEach((interaction) => {
            interaction.setActive(status);
        });

    }
    createSelectInteraction = (options) => {
        try {
            let layerList = [];

            for (let i = 0; i < options.layers.length; i++) {

                let layer = this.findLayer(options.layers[i]);

                if (layer instanceof VectorLayer) {
                    if (layer) {
                        layerList.push(layer);
                    }
                }
            }

            if (layerList.length === 0) {
                console.error('No valid vector layers found for select interaction.');
                return null;
            }

            const interaction = new CustomSelect({
                layers: layerList
            });

            interaction.set("name", options.name);

            interaction.setActive(false);

            return interaction;
        } catch (error) {
            console.log(error)
        }

    };
    createCustomSelectInteraction = (options) => {
        try {

            const interaction = new CustomSelect({
                layers: [],
                condition: options.condition,
                style: options.style,
                filter: options.filter
            });
            for (let i = 0; i < options.layers.length; i++) {

                interaction.addLayers(options.layers[i]);
            }

            interaction.set("name", options.name);

            interaction.setActive(false);

            return interaction;
        } catch (error) {
            console.log(error)
        }

    };
    createSelectInteraction3 = (opts) => {

        let layerList = [];

        for (var i = 0; i < opts.layers.length; i++) {
            layerList.push(this.findLayer2(opts.layers[i]));
        }

        const interaction = new Select({
            layers: layerList,
            condition: opts.condition,
            style: opts.style,
            filter: opts.filter
        });

        interaction.set("name", opts.name);

        interaction.setActive(false);

        return interaction;
    };

    setDoubleClickZoomActive = (status) => {

        let interaction = this.map
            .getInteractions()
            .getArray()
            .find((x) => x instanceof DoubleClickZoom);

        interaction.setActive(status);
    };

    modifyToolManagement = () => {

    }

    removeInteraction = (name) => {

        const interaction = this.getInteraction(name);

        if (interaction !== undefined) {

            this.map.removeInteraction(interaction);
        }
    };

    setFeatureGeometry = (targetFeature, sourceFeature) => {

        targetFeature.getGeometry().setCoordinates(sourceFeature.getGeometry().getCoordinates());
    };

    clearSelectInteraction = (name) => {

        this.getSelectInteractionFeatures(name).clear();
    }

    createSelectModifyInteraction = (options) => {

        let layerList = [];

        for (let i = 0; i < options.layers.length; i++) {

            let layer = this.findLayer(options.layers[i]);

            if (layer) {
                layerList.push(layer);
            }
        }

        let interactions = {};

        const selectInteraction = new CustomSelect({
            layers: layerList
        });

        const modifyInteraction = new Modify({
            features: selectInteraction.getFeatures(),
        });

        selectInteraction.set("name", options.selectName);

        selectInteraction.setActive(false);

        modifyInteraction.set("name", options.modifyName);

        modifyInteraction.setActive(false);

        interactions = {
            selectInteraction: selectInteraction,
            modifyInteraction: modifyInteraction
        }

        return interactions;
    }

    createSnapInteraction = (layerName, snapName) => {
        const source = this.getLayerSource(layerName);

        const interaction = new Snap({
            source: source
        });

        interaction.set("name", snapName);

        interaction.setActive(false);

        return interaction;
    };

    createSelectTransformInteraction = (nameSelect, nameTranslate, layers = []) => {
        let layerList = [];

        for (let i = 0; i < layers.length; i++) {

            const layer = this.findLayer(layers[i]);

            if (layer) {
                layerList.push(layer);
            }
        }

        let interactions = {};

        const select = new CustomSelect({
            layers: layerList
        });

        const translate = new CustomTranslate({
            features: select.getFeatures(),
        });

        select.set("name", nameSelect);

        select.setActive(false);

        translate.set("name", nameTranslate);

        translate.setActive(false);

        interactions = {
            selectInteraction: select,
            translateInteraction: translate
        }

        return interactions;
    }

    createSelectRotateInteraction = (nameSelect, nameRotate, layers = []) => {
        let layerList = [];

        for (let i = 0; i < layers.length; i++) {

            const layer = this.findLayer(layers[i]);

            if (layer) {
                layerList.push(layer);
            }
        }

        let interactions = {};

        const select = new CustomSelect({
            layers: layerList
        });

        const rotate = new RotateFeatureInteraction({
            features: select.getFeatures(),
            anchor: [0, 0],
            angle: -90 * Math.PI / 180
        })

        select.set("name", nameSelect);

        select.setActive(false);

        rotate.set("name", nameRotate);

        rotate.setActive(false);

        interactions = {
            selectInteraction: select,
            rotateInteraction: rotate
        }

        return interactions;
    }

    getInteraction = (name) => {

        let interaction = this.map.getInteractions().
            getArray().
            find(x => x.get("name") === name);

        return interaction;
    }

    getActiveInteraction = () => {

        let interaction = this.map.
            getInteractions().
            getArray().
            find(x => x.get("name") && x.get("active"))

        return interaction;
    }

    getMouseControl = () => {

        return new MousePosition({
            projection: 'EPSG:4326',
            className: 'custom-mouse-degree-position',
            coordinateFormat: (coordinate) => {

                if (this.mouseControlProjection !== "EPSG:4326") {

                    return olCoordinate.format(
                        proj4('EPSG:4326', this.mouseControlProjection, coordinate), this.mouseControlOutput, 2)
                }
                return olCoordinate.format(
                    proj4('EPSG:4326', this.mouseControlProjection, coordinate), this.mouseControlOutput, 6)
            },
            target: document.getElementById('mouse-degree-position'),
            undefinedHTML: "Mouse Harita Dışında"
        });
    }

    addBaseMap = (initialBaseMap = "OSM") => {

        let baseLayer = MapTool.createTileLayer({
            name: OlDefault.olBaseLayer.layerTitle,
            source: baseMaps.find(x => x.id === initialBaseMap).source,
            title: initialBaseMap
        });

        this.addLayer(baseLayer);
    }

    setGlbBaseMap = (selectedBaseMap) => {
        this.lclSelectedBaseMap = "";
        this.glbSelectedBaseMap = selectedBaseMap;
        if (this.getMap().getView().getZoom() > 21 && selectedBaseMap == "YR") {
            this.changeBaseMap("NONE");
            this.lclSelectedBaseMap = "NONE";
        }
        else {
            this.changeBaseMap(selectedBaseMap);
        }

    }

    changeBaseMap = (selectedBaseMap) => {
        let baseMapLayer = this.findLayer(OlDefault.olBaseLayer.layerTitle);

        if (baseMapLayer) {

            const baseMap = baseMaps.find(x => x.id === selectedBaseMap);

            const source = baseMap ? baseMap.source : null;

            baseMapLayer.setSource(source);

            if (source != null) {

                let tileLoading = 0;

                let tileLoaded = 0;

                let run = 0;

                let that = this;

                source.on('tileloadstart', x => ++tileLoading);

                source.on('tileloadend', x => {

                    ++tileLoaded;

                    if (tileLoaded === tileLoading && run <= 0) {

                        run++;
                    }

                });

                let controls = that.getMap().getControls();

                let array = controls.getArray();

                let customOmDiv = document.getElementsByClassName('custom-om');

                if (customOmDiv[0] && !customOmDiv[0].classList.contains("ol-collapsed")) {
                    const overViewMapLeftStyle = document.getElementsByClassName("ol-custom-overviewmap")[0].style.left;
                    const overViewMapRightStyle = document.getElementsByClassName("ol-custom-overviewmap")[0].style.right;
                    const overViewMapFloatStyle = document.getElementsByClassName("ol-custom-overviewmap")[0].style.float;
                    for (let i = 0; i < array.length; i++) {
                        if (array[i].element.className.includes("ol-overviewmap") || array[i] instanceof OverviewMap) {

                            that.getMap().removeControl(array[i]);
                        }
                    }

                    if (!source) {
                        source = MapTool.createOsmSource({
                            crossOrigin: 'Anonymous',
                            url: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'
                        })
                    }

                    let overviewMapControl = new OverviewMap({
                        className: 'ol-overviewmap ol-custom-overviewmap custom-om',
                        id: 'custom-overview',
                        layers: [
                            new TileLayer({
                                source: source
                            }),
                        ],
                        target: "map",
                        collapseLabel: '\u00BB',
                        label: '\u00AB',
                        collapsed: false,
                    });

                    that.getMap().addControl(overviewMapControl);

                    if (document.getElementsByClassName("ol-custom-overviewmap").length > 0) {
                        document.getElementsByClassName("ol-custom-overviewmap")[0].style.left = overViewMapLeftStyle;
                        document.getElementsByClassName("ol-custom-overviewmap")[0].style.right = overViewMapRightStyle;
                        document.getElementsByClassName("ol-custom-overviewmap")[0].style.float = overViewMapFloatStyle;
                    }
                }
            }

            this.getMap().on('moveend', () => {

                if (this.glbSelectedBaseMap === "YR") {
                    if (this.getMap().getView().getZoom() > 21 && this.lclSelectedBaseMap != "NONE") {
                        this.changeBaseMap("NONE");
                        this.lclSelectedBaseMap = "NONE";
                    }
                    if (this.getMap().getView().getZoom() <= 21 && this.lclSelectedBaseMap == "NONE") {

                        this.lclSelectedBaseMap = "";
                        this.changeBaseMap(this.glbSelectedBaseMap);

                    }

                }
            });
        }
    }

    enableInteraction = (name) => {

        const interaction = this.getInteraction(name);

        interaction.setActive(true)
    }

    enableOrDisableModifyToolInteraction = (enable = true) => {
        if (enable) {
            const selectEditInteraction = this.getInteraction("select_edit_interaction");
            if (selectEditInteraction) {
                selectEditInteraction.setActive(true);
                selectEditInteraction.getFeatures().clear();
            }

            const selectEditHoverInteraction = this.getInteraction("select_hover_interaction");
            if (selectEditHoverInteraction) {
                selectEditHoverInteraction.setActive(true);
            }

            const modifyInteraction = this.getInteraction("modify_interaction");
            if (modifyInteraction) {
                modifyInteraction.setActive(true);
            }
        }
        else {
            const selectEditInteraction = this.getInteraction("select_edit_interaction");
            if (selectEditInteraction) {
                selectEditInteraction.setActive(false);
                selectEditInteraction.getFeatures().clear();
            }

            const selectEditHoverInteraction = this.getInteraction("select_hover_interaction");
            if (selectEditHoverInteraction) {
                selectEditHoverInteraction.setActive(false);
                selectEditHoverInteraction.getFeatures().clear();
            }

            const modifyInteraction = this.getInteraction("modify_interaction");
            if (modifyInteraction) {
                modifyInteraction.setActive(false);
            }
        }
    }

    disableInteraction = (name) => {

        const interaction = this.getInteraction(name);

        interaction.setActive(false)
    }

    disableAllInteractions = () => {

        this.getMap().getInteractions().getArray()
            .filter(x => x.get("name") && !x.get("name").includes("Snap") && !x.get("name").includes("snap"))
            .forEach((i) => {
                i.setActive(false);
            });
    }

    getZoom = () => this.getView().getZoom();

    shortCut = (event) => {

        let charCode = (event.which) ? event.which : event.keyCode;

        if (charCode === 27) {

            pan();
        }
    }

    pan = () => {

        let interaction = this.getActiveInteraction();

        if (interaction) {

            interaction.setActive(false);
        }
    }

    updateLayerSource = (name, params) => this.getLayerSource(name).updateParams(params);

    getLayerSource = (name) => this.findLayer(name).getSource();

    getLayerByThematic = () => this.findLayer('thematiclayer');

    findLayer = (name) => this.map.getLayers().getArray().find(x => x.get("name") === name);

    findLayer2 = (name) => this.map.getLayers().getArray().find(x => x.get("name") == name);

    findFeatureAtExtent = (feature) => {
        const vectorLayers = this.map.getLayers().getArray().filter((x) => x.get("name").includes("wfs-layer") || x.get("name").includes("bas-wfs-layer"));
        const features = this.getLayersFeatures(vectorLayers);
        const focusedFeature = features.getArray().find(obj =>
            feature.getGeometry().intersectsExtent(obj.getGeometry().getExtent()) &&
            (!feature.get("id") || obj.get("id") === feature.get("id"))
        );

        return focusedFeature;
    }

    getWfsLayerWithId = (layerId, type = "WFS") => {
        if (type === "WFS") {
            return this.findLayer("wfs-layer-" + layerId);
        }

        if (type === "BASEWFS") {
            return this.findLayer("base-wfs-layer-" + layerId);
        }

        return null;
    }

    static createTileLayerSource = (options) => {

        const opts = { ...OlDefault.olTileWmsSource, ...options };

        return new TileSource({
            urls: opts.urls,
            crossOrigin: opts.crossOrigin,
            params: opts.params,
            format: opts.format,
            width: 256,
            height: 256
        });
    }

    static createVectorLayerSource = (options) => {

        const opts = { ...OlDefault.olVectorSource, ...options };

        return new VectorSource({
            format: opts.format,
            loader: opts.loader,
            projection: opts.projection,
            features: opts.feature
        });
    }

    static createImageSource = (options) => {

        const opts = { ...OlDefault.olTileWmsSource, ...options };

        return new ImageWMS({
            url: opts.url,
            crossOrigin: opts.crossOrigin,
            params: opts.params,
            serverType: 'geoserver',
            imageLoadFunction: opts.imageLoadFunction
        });
    }

    static createImageLayer = (options) => {
        const opts = { ...OlDefault.olTileWmsSource, ...options };

        return new ImageLayer({
            source: opts.source,
            name: opts.name,
            zIndex: 999
        });
    }

    static createTileLayer = (options) => {

        const opts = { ...OlDefault.olTileLayer, ...options };

        return new TileLayer({
            source: opts.source,
            name: opts.name,
            visible: opts.visible,
            title: opts.title
        });
    }

    // Bütün seviyelerdeki karoları almak için yazıldı.
    static createTileLayerForBaseMap = (options) => {

        const opts = { ...OlDefault.olTileLayer, ...options };

        return new TileLayer({
            source: opts.source,
            name: opts.name,
            visible: opts.visible,
            title: opts.title,
            preload: Infinity
        });
    }

    static createVectorLayer = (options) => {

        const opts = { ...OlDefault.olVectorLayer, ...options };

        return new VectorLayer({
            opacity: opts.opacity,
            source: opts.source,
            name: opts.name,
            visible: opts.visible
        });
    }

    createPopupOverlay = (id, popupId) => {
        let overlay = new Overlay({
            id: id,
            element: document.getElementById(popupId),
            autoPan: true,
            autoPanAnimation: {
                duration: 250,
            },
        });
        this.addOverlay(overlay);
    }

    setPopupPosition = (coordinate, overlayName, closerId) => {

        let closer = document.getElementById(closerId);
        this.getOverlay(overlayName).setPosition(coordinate);
        let that = this;
        if (closer) {
            closer.onclick = function () {
                that.getOverlay(overlayName).setPosition(undefined);
                closer.blur();
                return false;
            };
        }
    }

    static createVectorImageLayer = (options) => {

        const opts = { ...OlDefault.olVectorLayer, ...options };

        return new VectorImageLayer({
            opacity: opts.opacity,
            source: opts.source,
            name: opts.name,
            visible: opts.visible,
            style: opts.style
        });
    };

    static transformProjection = (feature, sourceProjection, destinationProjection) => {

        if (!destinationProjection) {

            destinationProjection = OlDefault.olOptions.view.projection
        }

        return transform(feature.getCoordinates(), sourceProjection, destinationProjection);
    }

    static convertToFeature = (wkt, wktProjection, featureProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new WKT().readFeature(wkt, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    convertToFeatureNotStatic = (wkt,
        wktProjection = this.wktProjection,
        featureProjection = this.mapProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new WKT().readFeature(wkt, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertToWkt = (feature, wktProjection, featureProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new WKT().writeGeometry(feature.getGeometry(), {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertToWktWithDecimalOption = (feature, wktProjection, featureProjection, decimals = 8) => {

        try {
            if (feature.getGeometry().getLayout().length > 2)
                feature.getGeometry().setCoordinates(feature.getGeometry().getCoordinates(), 'XY');
        } catch (e) {
        }
        return new WKT().writeGeometry(feature.getGeometry(), {
            dataProjection: wktProjection,
            featureProjection: featureProjection,
            decimals: decimals
        });
    };

    convertToWktNotStatic = (feature,
        wktProjection = this.wktProjection,
        featureProjection = this.mapProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new WKT().writeGeometry(feature.getGeometry(), {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertFeatureToGeoJson = (feature, wktProjection, featureProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new GeoJson().writeFeature(feature, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertKMLToFeature = (kml, wktProjection, featureProjection) => {

        return new KML().readFeatures(kml, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertFeaturesToGeoJson = (features, wktProjection, featureProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new GeoJson().writeFeatures(features, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertGeoJsonToFeature = (source, wktProjection, featureProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new GeoJson().readFeature(source, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    convertGeoJsonToFeatureNotStatic = (source,
        wktProjection = this.wktProjection,
        featureProjection = this.mapProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new GeoJson().readFeature(source, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static convertGeoJsonToFeatures = (source, wktProjection, featureProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new GeoJson().readFeatures(source, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    convertGeoJsonToFeaturesNotStatic = (source,
        wktProjection = this.wktProjection,
        featureProjection = this.mapProjection) => {

        if (!featureProjection) {

            featureProjection = OlDefault.olOptions.view.projection
        }

        return new GeoJson().readFeatures(source, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    addOverlayCustom = (elem, id) => {

        const element = document.getElementById(elem);

        const popup = new Overlay({
            id: id,
            element: element,
            positioning: 'bottom-center',
            stopEvent: true,
        });

        this.getMap().addOverlay(popup);

        return popup;
    }
    getOverlay = (id) => {
        return this.getMap().getOverlays().getArray().find(x => x.id == id);
    };
    createOverlay = (id, element, positioning, offset) => {

        const overlay = new Overlay({
            id: id,
            element: element,
            offset: offset,
            positioning: positioning,
        });
        overlay.set("name", "name");

        return overlay;
    };
    addOverlay = (overlay) => {

        this.getMap().addOverlay(overlay);
    }
    setOverlayPosition = (id, position) => {

        let overlay = this.getOverlay(id);

        if (overlay !== undefined) {

            overlay.setPosition(position);
        }
    }
    removeOverlay = (id) => {

        let overlay = this.getOverlay(id);

        if (overlay !== undefined) {

            this.getMap().removeOverlay(overlay);
        }
    };
    setFeatureStyleIcon = (style) => {
        if (style) {
            if (style.isCircle) {
                return new Style({
                    image: new CircleStyle({
                        radius: 10,
                        fill: new Fill({
                            color: style.fillColor ? style.fillColor : 'rgba(255, 0, 0, 0.2)',
                        }),
                        stroke: new Stroke({
                            color: style.strokeColor ? style.strokeColor : '#ff0000',
                            width: style.strokeWidth ? style.strokeWidth : 2,
                        }),
                    }),
                });
            }
            else if (style.src) {
                return new Style({
                    image: new Icon({
                        anchor: [0.5, 46],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'pixels',
                        src: style.src
                    }),
                });
            }
        }
    }

    clearMap = () => {

        const vectorLayers = this.map.getLayers().
            getArray().
            filter(x => x instanceof VectorLayer && x.get('name') !== 'regionlayer' && x.get('name') !== 'workspace-database-layer' && !x.get('name').includes("base-wfs-layer-") && !x.get('name').includes("wfs-layer-"));

        if (this.findLayer("segment-based-length-measurement-layer")) {
            this.clearLayersByName(["segment-based-length-measurement-layer"]);
        }

        if (document.getElementById("drawMeasure") !== null) {

            document.querySelectorAll(".ol-overlay-container.ol-selectable").forEach((data) => { data.remove() });
        }

        document.querySelectorAll(`[id*='draw-line-measure']`).forEach(element => {
            this.getMap().getOverlays().forEach(overlay => {
                if (overlay) {
                    if (overlay.getElement() === element) {
                        this.getMap().removeOverlay(overlay);
                    }
                }
            })
            element.remove();
        });

        document.querySelectorAll(`[id*='draw-area-measure']`).forEach(element => {
            this.getMap().getOverlays().forEach(overlay => {
                if (overlay) {
                    if (overlay.getElement() === element) {
                        this.getMap().removeOverlay(overlay);
                    }
                }
            })
            element.remove();
        });

        MapTool.clearLayers(vectorLayers);

        const thematicLayer = this.findLayer("dq-thematic-layer");

        if (thematicLayer) {
            this.getMap().removeLayer(thematicLayer);
        }
    }

    zoomToCoordinatesWithIcon = (feature, zoomLevel, layer = "info-layer",
        iconPath = "dot.png") => {

        this.clearLayersByName(["info-layer"]);

        let opacity = 1;

        feature.setStyle(
            new Style({
                image: new Icon({
                    src: iconPath,
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'pixels',
                    scale: 1.5,
                    opacity: opacity
                })
            }),
        );

        this.addFeature(layer, feature);

        this.viewLayerExtent(layer, feature, zoomLevel);
    };

    clearLayersByName = (names) => {

        for (const name of names) {

            this.getLayerSource(name).clear();
        }
    }

    static clearLayers = (layers) => {

        for (const layer of layers) {

            layer.getSource().clear();
        }
    }

    clearLayerByThematic = () => {

        let thematicLayerSource = this.findLayer('thematiclayer').getSource();

        thematicLayerSource.params_ = {};

        thematicLayerSource.refresh();

        let timer = setTimeout(() => { thematicLayerSource.url_ = ''; }, 1000);

        clearTimeout(timer);
    }

    refreshLayer = (name) => {

        const source = this.getLayerSource(name);

        const params = source.getParams();

        params.t = new Date().getMilliseconds();

        source.updateParams(params);
    }

    refreshWmsLayer = () => this.refreshLayer("wms-layer");

    viewLayerExtent = (layerName, feature, zoomLevel) => {

        if (this.getLayerSource(layerName).getFeatures().length > 0) {

            let _extent = new Feature();

            if (feature) {

                _extent = feature.getGeometry()
            }
            else {

                _extent = this.getLayerSource(layerName).getExtent();
            }

            if (!zoomLevel) {

                this.getView().fit(_extent);
            } else {

                this.getView().fit(_extent);

                this.getView().setZoom(zoomLevel);
            }
        }
    }

    viewFeatureExtent = (feature, zoomLevel) => {

        if (feature) {
            let _extent = new Feature();

            _extent = feature.getGeometry();

            if (!zoomLevel) {
                this.getView().fit(_extent);
            }
            else {
                this.getView().fit(_extent);

                this.getView().setZoom(zoomLevel);
            }
        }
    }

    getMapExtent = (options, onComplate) => {

        let extent = this.getView().calculateExtent(this.getMap().getSize());

        if (onComplate) {

            onComplate(extent);
        }
        else {
            return extent;
        }
    }

    static createPoint = function (options) {

        let point = new Point(options.coordinate);

        return new Feature({
            name: 'Point',
            geometry: point
        });
    };


    static hexToRgb = (hex) => {
        let bigint = parseInt(hex.slice(1), 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;

        return [r, g, b];
    }

    static hexToRgba = (hex, opacity) => {
        let rgb = this.hexToRgb(hex);
        if (opacity > 1) {
            opacity = opacity / 100;
        }
        return 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + opacity + ')';
    }

    getDefaultStyle = (label = "", state, geoType) => {

        let that = this;
        let statusDash = false;

        if (state.lineType?.name == "Kesikli") {
            statusDash = true;
        }

        let alpha = state.opacity < 10 ? "0" + state.opacity : state.opacity == "100" ? "" : state.opacity;

        let textStyle = new Text({
            text: label,
            textAlign: state.textScroll.code,
            textBaseline: state.textPosition.code,
            font: state.styleType.code + ' ' + state.textSize + "px " + state.font.code,
            rotation: state.textRotate ? state.textRotate : 0,
            fill: new Fill({
                color: state.textColor
            }),
            stroke: new Stroke({
                color: state.textSurroundingsColor,
            }),
            backgroundFill: !state.textShadow ?
                undefined :
                new Fill({
                    color: 'white'
                }),
        });

        let image;
        let opacity = MapTool.hexToRgba(state.geometryColor, alpha);

        if (geoType == "Point") {

            switch (state.pointType.code) {
                case "square":
                    image = new RegularShape({
                        fill: new Fill({ color: opacity }),
                        stroke: new Stroke({ color: state.pointSurroundingsColor, width: 1 }),
                        points: 4,
                        radius: state.pointSize,
                        angle: Math.PI / 4
                    })
                    break;
                case "triangle":
                    image = new RegularShape({
                        fill: new Fill({ color: opacity }),
                        stroke: new Stroke({ color: state.pointSurroundingsColor, width: 1 }),
                        points: 3,
                        radius: state.pointSize,
                        rotation: Math.PI / 4,
                        angle: 0
                    })
                    break;
                case "star":
                    image = new RegularShape({
                        fill: new Fill({ color: opacity }),
                        stroke: new Stroke({ color: state.pointSurroundingsColor, width: 1 }),
                        points: 5,
                        radius: state.pointSize,
                        radius2: 4,
                        angle: 0
                    })
                    break;
                case "x":
                    image = new RegularShape({
                        fill: new Fill({ color: opacity }),
                        stroke: new Stroke({ color: state.pointSurroundingsColor, width: 1 }),
                        points: 4,
                        radius: state.pointSize,
                        radius2: 0,
                        angle: Math.PI / 4
                    })
                    break;
                default:
                    image = new CircleStyle({
                        radius: state.pointSize,
                        fill: new Fill({ color: opacity }),
                        stroke: new Stroke({ color: state.pointSurroundingsColor, width: 1 }),
                    });
            }

            return new Style({
                text: textStyle,
                image: image,
                zIndex: 1
            });

        }
        else if (geoType == "LineString" || geoType == "MultiLineString") {

            return new Style({

                text: textStyle,
                stroke: new Stroke({
                    color: opacity,
                    width: state.lineThickness,
                    lineDash: statusDash ? [0.1, 10] : [0.0]
                })
            });
        }
        else {
            return new Style({
                text: textStyle,
                fill: new Fill({
                    color: MapTool.hexToRgba(state.polygonFillColor, alpha),
                }),
                stroke: new Stroke({
                    color: opacity,
                    width: state.lineThickness,
                    lineDash: statusDash ? [0.1, 10] : statusDash ? [0.1, 10] : [0.0]
                }),
                zIndex: 1
            });

        }
    }

    styleFunction = (data) => (feature) => {

        const attributes = feature.getProperties();

        let firstAttribute = "";

        let geoType = feature.getGeometry().getType()

        if (data.label && data.label.length > 0) {

            data.label.forEach(element => {
                firstAttribute = firstAttribute + " " + (attributes[element] ? attributes[element].toString() : '');
            });
        }
        if (data.filterDataList && data.filterDataList.length > 0) {
            let applyStyle = false;
            let state = null
            data.filterDataList.forEach(data => {
                data.filterList.forEach(element => {
                    const attributeValue = attributes[element.columnName];

                    switch (element.filterType) {
                        case "Eşittir":
                            if (attributeValue == element.filterValue) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Eşit değildir":
                            if (attributeValue != element.filterValue) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Başlar":
                            if (attributeValue.startsWith(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Biter":
                            if (attributeValue.endsWith(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Büyüktür":
                            if (parseFloat(attributeValue) > parseFloat(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Küçüktür":
                            if (parseFloat(attributeValue) < parseFloat(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Büyük eşittir":
                            if (parseFloat(attributeValue) >= parseFloat(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Küçük eşittir":
                            if (parseFloat(attributeValue) <= parseFloat(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "İçerir":
                            if (attributeValue.includes(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "İçermez":
                            if (!attributeValue.includes(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Arasında":

                            if (parseFloat(attributeValue) < parseFloat(element.filterSecondValue) && parseFloat(attributeValue) > parseFloat(element.filterValue)) {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Boş":
                            if (!attributeValue && attributeValue.trim() == "") {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        case "Boş değil":
                            if (attributeValue || attributeValue.trim() != "") {
                                applyStyle = true;
                                state = data.filterState
                            }
                            break;
                        default:
                            break;
                    }
                });
            })

            if (applyStyle) {
                let style = this.getDefaultStyle((firstAttribute.toString() || ''), state, geoType)

                return style;
            }
            else {
                let style = this.getDefaultStyle((firstAttribute.toString() || ''), data.layerState, geoType)

                return style;
            }
        }
        else if (data.layerState) {
            let style = this.getDefaultStyle((firstAttribute.toString() || ''), data.layerState, geoType)

            return style;
        }
        else {
            return new Style({
                stroke: new Stroke({
                    color: 'red',
                    width: 5,
                    lineDash: [0.1, 10]
                }),
                fill: new Fill({
                    color: 'red',
                }),
                image: new Circle({
                    radius: 5,
                    fill: new Fill({
                        color: 'red'
                    }),
                    stroke: new Stroke({
                        color: 'red',
                    }),
                }),
                zIndex: 1000
            })
        }

    };

    defaultWfsStyle = () => {

        return new Style({
            stroke: new Stroke({
                color: 'red',
                width: 10,
                lineDash: [0.1, 10]
            }),
            fill: new Fill({
                color: 'red',
            }),
            image: new Circle({
                radius: 5,
                fill: new Fill({
                    color: 'red'
                }),
                stroke: new Stroke({
                    color: 'red',
                }),
            }),
            zIndex: 1000
        })

    }

    createWfsLayer = (options) => {
        let that = this;
        try {
            if (!this.findLayer(options.name)) {

                const opts = { ...OlDefault.olWfsOptions, ...options };
                let sourceVector = new VectorSource({
                    format: opts.format,
                    //urls: opts.urls,
                    // url: (extent) => { return (opts.url + extent.join(',') + ',' + opts.projection) },
                    strategy: opts.strategy,
                    loader: function (extent, resolution, projection) {
                        //var proj = projection.getCode();
                        var url = opts.url;
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url);
                        let ex = that.getView().calculateExtent(that.getMap().getSize());
                        xhr.setRequestHeader('ozt', localStorage.getItem(window.layerControlTokenKey));
                        xhr.setRequestHeader('layers', JSON.stringify(options.layers));
                        xhr.setRequestHeader('extend', ex);

                        var onError = function () {
                            sourceVector.removeLoadedExtent(extent);
                        }

                        xhr.onerror = onError;

                        xhr.onload = function () {
                            if (xhr && xhr.status == 200) {

                                if (xhr && otherTool.isJsonString(xhr?.responseText)) {
                                    let dataProjection = JSON.parse(xhr?.responseText)?.crs?.properties?.name;

                                    sourceVector.addFeatures(
                                        sourceVector.getFormat().readFeatures(xhr.responseText, {
                                            dataProjection: dataProjection,
                                            featureProjection: "EPSG:3857"
                                        }));
                                }
                            }
                            else {
                                onError();
                            }
                        }
                        xhr.send();
                    },
                });

                return new VectorLayer(
                    {
                        name: opts.name,
                        source: sourceVector,
                        minZoom: opts.minZoom,
                        maxZoom: opts.maxZoom,
                        style: opts.style,

                    }
                );
            } else {

                return this.findLayer(options.name);
            }

        } catch (error) {

        }
    }

    static createTileGrid = () => {
        const projExtent = getProjection2('EPSG:3857').getExtent();
        const startResolution = getWidth(projExtent) / 256;
        const resolutions = new Array(30);
        for (let i = 0, ii = resolutions.length; i < ii; ++i) {
            resolutions[i] = startResolution / Math.pow(2, i);
        }

        return new TileGrid({
            extent: [-20037508.34, -20048966.1, 20037508.34, 20048966.1],
            resolutions: resolutions,
            tileSize: [512, 512],
        });
    }

    static createTileWmtsGrid = () => {
        const projExtent = getProjection2('EPSG:3857').getExtent();
        const startResolution = getWidth(projExtent) / 256;
        const resolutions = new Array(22);
        const matrixIds = new Array(22);
        for (let i = 0, ii = resolutions.length; i < ii; ++i) {
            resolutions[i] = startResolution / Math.pow(2, i);
            matrixIds[i] = i;
        }

        return new WMTSTileGrid({
            origin: projExtent,
            resolutions: resolutions,
            matrixIds: matrixIds,
        })
    }

    static createTileGridForProjection = (projectionCode) => {
        const projection = getProjection2(projectionCode);
        const extent = projection.getExtent();
        const size = getWidth(extent) / 512; // Tile boyutunu belirler
        const resolutions = new Array(22).fill(0).map((_, z) => size / Math.pow(2, z));
        const tileGrid = new TileGrid({
            extent: extent,
            resolutions: resolutions,
            tileSize: [512, 512],
            origin: getTopLeft(extent)
        });

        return tileGrid;
    }

    static setFeatureStyleFromGetDb = (type, featureValues) => {

        let style;

        switch (type) {
            case "addGenerateTag":
                style = new Style({
                    text: new Text({
                        textAlign: featureValues.textAlign,
                        font: featureValues.stil + ' ' + featureValues.size + "px " + featureValues.font,
                        text: featureValues.name,
                        fill: new Fill({
                            color: featureValues.textColor
                        }),
                        backgroundFill: !featureValues.shading ?
                            undefined :
                            new Fill({
                                color: 'white'
                            }),
                        stroke: new Stroke({ color: featureValues.fillColor ? '#aa3300' : null, width: false ? parseInt(12 / 3) : 0 }),
                        rotation: featureValues.rotation
                    })
                });
                return style;

            case "addPoint":
                let alpha = featureValues.fillOpacityPoint < 10 ? "0" + featureValues.fillOpacityPoint : featureValues.fillOpacityPoint === "100" ? "" : featureValues.fillOpacityPoint;

                let image;
                switch (featureValues.regularType) {
                    case "square":
                        image = new RegularShape({
                            fill: new Fill({ color: this.hexToRgba(featureValues.circleFill, alpha) }),
                            stroke: new Stroke({ color: this.hexToRgba(featureValues.circleStroke, 1), width: 1 }),
                            points: 4,
                            radius: featureValues.size,
                            angle: Math.PI / 4
                        });
                        break;
                    case "triangle":
                        image = new RegularShape({
                            fill: new Fill({ color: this.hexToRgba(featureValues.circleFill, alpha) }),
                            stroke: new Stroke({ color: this.hexToRgba(featureValues.circleStroke, 1), width: 1 }),
                            points: 3,
                            radius: featureValues.size,
                            rotation: Math.PI / 4,
                            angle: 0
                        });
                        break;
                    case "star":
                        image = new RegularShape({
                            fill: new Fill({ color: this.hexToRgba(featureValues.circleFill, alpha) }),
                            stroke: new Stroke({ color: this.hexToRgba(featureValues.circleStroke, 1), width: 1 }),
                            points: 5,
                            radius: featureValues.size,
                            radius2: featureValues.size / 2.5,
                            angle: 0
                        });
                        break;
                    case "x":
                        image = new RegularShape({
                            fill: new Fill({ color: this.hexToRgba(featureValues.circleFill, alpha) }),
                            stroke: new Stroke({ color: this.hexToRgba(featureValues.circleStroke, 1), width: 1 }),
                            points: 4,
                            radius: featureValues.size,
                            angle: 0
                        });
                        break;
                    case "circle":
                    default:
                        image = new CircleStyle({
                            radius: featureValues.size,
                            fill: new Fill({ color: this.hexToRgba(featureValues.circleFill, alpha) }),
                            stroke: new Stroke({ color: this.hexToRgba(featureValues.circleStroke, 1), width: 1 }),
                        });
                        break;
                }

                let textStyle = new Text({
                    textAlign: featureValues.textAlign,
                    textBaseline: featureValues.textBaseline,
                    font: featureValues.stil + ' ' + featureValues.size + "px " + featureValues.font,
                    text: featureValues.name.toString(),
                    fill: new Fill({
                        color: featureValues.textColor
                    }),
                    backgroundFill: !featureValues.shading ?
                        undefined :
                        new Fill({
                            color: 'white'
                        }),
                    stroke: new Stroke({ color: featureValues.fillColor ? '#aa3300' : null, width: false ? parseInt(12 / 3) : 0 }),
                    rotation: featureValues.rotation
                });

                style = new Style({
                    text: textStyle,
                    image: image,
                    zIndex: 1
                });

                return style;

            case "addLine":
                let textLineStyle = new Text({
                    textAlign: featureValues.textAlign,
                    textBaseline: featureValues.textBaseline,
                    font: featureValues.stil + ' ' + featureValues.size + "px " + featureValues.font,
                    text: featureValues.name,
                    fill: new Fill({
                        color: featureValues.textColor
                    }),
                    backgroundFill: !featureValues.shading ?
                        undefined :
                        new Fill({
                            color: 'white'
                        }),
                    stroke: new Stroke({ color: featureValues.fillColor ? '#aa3300' : null, width: false ? parseInt(12 / 3) : 0 }),
                    rotation: featureValues.rotation
                });

                let lineAlpha = featureValues.fillOpacity < 10 ? "0" + featureValues.fillOpacity : featureValues.fillOpacity === "100" ? "" : featureValues.fillOpacity;

                style = new Style({
                    text: textLineStyle,
                    stroke: new Stroke({
                        color: this.hexToRgba(featureValues.lineColor, lineAlpha),
                        width: featureValues.width,
                        lineDash: featureValues.lineDash === 'dashed' ? [0.1, 10] : undefined
                    })
                });

                return style;

            case "addArea":
                let textPolygonStyle = new Text({
                    textBaseline: featureValues.textBaseline,
                    textAlign: featureValues.textAlign,
                    font: featureValues.stil + ' ' + featureValues.size + "px " + featureValues.font,
                    text: featureValues.name,
                    fill: new Fill({
                        color: featureValues.textColor
                    }),
                    backgroundFill: !featureValues.shading ?
                        undefined :
                        new Fill({
                            color: 'white'
                        }),
                    stroke: new Stroke({ color: featureValues.fillColor ? '#aa3300' : null, width: false ? parseInt(12 / 3) : 0 }),
                    rotation: featureValues.rotation
                });

                let polygonAlpha = featureValues.fillOpacity < 10 ? "0" + featureValues.fillOpacity : featureValues.fillOpacity === "100" ? "" : featureValues.fillOpacity;

                style = new Style({
                    text: textPolygonStyle,
                    fill: new Fill({
                        color: this.hexToRgba(featureValues.polygonFillColor, polygonAlpha),
                    }),
                    stroke: new Stroke({
                        color: this.hexToRgba(featureValues.lineColor, 1),
                        width: featureValues.lineThickness,
                        lineDash: featureValues.lineDash === 'dashed' ? [10, 5] : undefined
                    }),
                    zIndex: 1
                });

                return style;


            default:
                return;
        }
    }

    updateLayerSourceWithTileLoad = (name, params) => {
        let that = this;
        try {
            let source = this.getLayerSource(name);
            if (source) {
                source.updateParams(params);

                // if (params && params.crs && params.crs.length > 0) {
                //     source.setTileGridForProjection(params.crs[0], this.createTileGridForProjection(params.crs[0]))
                // }

                source.setTileLoadFunction(function (tile, src) {

                    let bboxReg, matches, coords;

                    if (params && params.SRS) {

                        bboxReg = /BBOX=([^&]+)/g; matches = bboxReg.exec(src);
                        coords = window.unescape(matches[1]).split(',').map(function (c) { return parseFloat(c); });

                        coords = transformExtent(coords, 'EPSG:3857', params.SRS);

                        src = src.replace(bboxReg, 'BBOX=' + window.escape(coords.join(',')));

                        src = src.replace(/SRS=[^&]+/g, 'SRS=' + window.escape(params.SRS));

                        // src = src.replace(/crs=[^&]+/g, "");
                        src = src.replace(/visibleLevel=[^&]+/g, "");
                        src = src.replace(/zoom=[^&]+/g, "");

                        if (params && params.visibleLevel) {
                            src = src.replace(/layers=[^&]+/g, "layers=" + params.visibleLevel.filter(y => y.maxVisibleLevel >= that.getZoom() && y.minVisibleLevel <= that.getZoom()).map(x => x.key).join(","));
                        }

                        src = src.replace("&&", "&");
                    }

                    fetch(src, {
                        method: 'GET',
                        headers: {
                            'ozt': localStorage.getItem(window.layerControlTokenKey),
                            'Content-Type': 'application/json'
                        },

                    }).then(response => {
                        return response.blob().then(blob => {

                            try {
                                var data = blob;

                                if (data !== undefined) {
                                    tile.getImage().src = URL.createObjectURL(data);
                                }
                                else {
                                    tile.setState(TileState.ERROR);
                                }
                            }
                            catch (e) {

                            }
                        })
                    }).catch(error => {
                        tile.setState(TileState.ERROR);
                    });
                });
            }
        } catch (e) {
            console.log(e);
        }

    }

    static createTileLayerSourceWithHeaders = (options) => {

        const opts = { ...OlDefault.olTileWmsSource, ...options };

        return new TileSource({
            urls: opts.urls,
            projection: opts.projection,
            crossOrigin: opts.crossOrigin,
            params: opts.params,
            format: opts.format,
            tileGrid: MapTool.createTileGrid(),
            tileLoadFunction: function (tile, src) {

                var xhr = new XMLHttpRequest();

                xhr.responseType = 'blob';

                let bboxReg, matches, coords;

                if (opts.params.crs && opts.params.crs.length > 0) {

                    bboxReg = /BBOX=([^&]+)/g; matches = bboxReg.exec(src);

                    coords = window.unescape(matches[1]).split(',').map(function (c) { return parseFloat(c); });

                    coords = transformExtent(coords, 'EPSG:3857', opts.params.crs[0]);

                    src = src.replace(bboxReg, 'BBOX=' + window.escape(coords.join(',')));

                    src = src.replace(/CRS=[^&]+/g, 'CRS=' + window.escape(opts.params.crs[0]));

                    src = src.replace(/crs=[^&]+/g, "");

                    if (opts && opts.params && opts.params.x) {
                        src = src.replace(/layers=[^&]+/g, "layers=" + opts.params.x.filter(y => y.maxVisibleLevel >= this.getZoom() && y.minVisibleLevel <= this.getZoom()).map(x => x.key).join(","));
                    }
                }

                xhr.addEventListener('loadend', function (evt) {

                    try {
                        var data = this.response;

                        if (data !== undefined) {
                            tile.getImage().src = URL.createObjectURL(data);
                        }
                        else {
                            tile.setState(TileState.ERROR);
                        }
                    } catch (e) {

                    }
                });

                xhr.addEventListener('error', function () {

                    tile.setState(TileState.ERROR);
                });

                xhr.open('GET', src);

                xhr.setRequestHeader('ozt', localStorage.getItem(window.mapTokenKey));

                xhr.send();
            }
        });
    }

    static createTileLayerSourceWithHeadersLy = (options) => {

        const opts = { ...this.olTileWmsSource, ...options };

        return new TileSource({
            urls: opts.urls,
            projection: opts.projection,
            crossOrigin: opts.crossOrigin,
            params: opts.params,
            format: opts.format,
            tileGrid: opts.tileGrid
        });
    }

    static createTileLayerWMTSSourceWithHeaders = (options, callback) => {
        try {
            const opts = { ...this.olTileWmsSource, ...options };

            const parser = new WMTSCapabilities();
            const result = parser.read(opts.capabilities);
            const _options = optionsFromCapabilities(result, {
                layer: opts.layerName
            });

            return new WMTS({
                url: opts.url,
                layer: opts.layerName,
                matrixSet: _options.matrixSet,
                format: "image/png",
                projection: _options.projection,
                tileGrid: _options.tileGrid,
                style: 'default',
                crossOrigin: 'anonymous',
                tileLoadFunction: (imageTile, src) => {
                    try {
                        src += "&LayerId=" + opts.layerId

                        imageTile.getImage().src = src;
                    } catch (error) {

                    }
                }
            });
        } catch (error) {

        }
    }

    static createWcsLayer = (opts) => {

        const extent = transformExtent(opts.extent, opts.params.crs, 'EPSG:3857');

        const wcsLayer = new ImageLayer({
            extent: extent,
            source: new ImageWMS({
                url: opts.url, // WCS servisinizin URL'sini buraya ekleyin
                params: opts.params, // Kullanmak istediğiniz kapsama alanının ID'sini buraya ekleyin
                serverType: 'mapserver',
                ratio: 1,
                imageLoadFunction: function (tile, src) {
                    let bboxReg, matches, coords;

                    if (opts.params && opts.params.crs) {

                        bboxReg = /BBOX=([^&]+)/g;
                        matches = bboxReg.exec(src);
                        coords = window.unescape(matches[1]).split(',').map(function (c) { return parseFloat(c); });

                        coords = transformExtent(coords, 'EPSG:3857', opts.params.crs);

                        src = src.replace(bboxReg, 'BBOX=' + window.escape(coords.join(',')));

                        src = src.replace(/CRS=[^&]+/g, 'CRS=' + window.escape(opts.params.crs));

                        src = src.replace(/crs=[^&]+/g, "");
                        src = src.replace(/x=[^&]+/g, "");
                        src = src.replace(/zoom=[^&]+/g, "");

                        src = src.replace("&&", "&");
                    }

                    fetch(src, {
                        method: 'GET',
                        headers: {
                            'ozt': localStorage.getItem(window.layerControlTokenKey),
                            'Content-Type': 'application/json'
                        },

                    }).then(response => {
                        return response.blob().then(blob => {

                            try {
                                var data = blob;

                                if (data !== undefined) {
                                    tile.getImage().src = URL.createObjectURL(data);
                                }
                                else {
                                    tile.setState(TileState.ERROR);
                                }
                            }
                            catch (e) {

                            }
                        })
                    }).catch(error => {
                        tile.setState(TileState.ERROR);
                    });
                }

            }),
            visible: true
        });

        return wcsLayer;
    }

    static featureAddLayerName = (jsonItem, layerName) => {
        let objectFeature = JSON.parse(jsonItem);

        objectFeature.featObjectName = layerName;

        let newObjectFeature = JSON.stringify(objectFeature);

        return newObjectFeature;
    }

    static convertToFeature = (wkt, wktProjection, featureProjection) => {

        return new WKT().readFeature(wkt, {
            dataProjection: wktProjection,
            featureProjection: featureProjection
        });
    }

    static getFeatureInMapActive = (activeLayer, workspaceId, mapTool) => {
        let obj;

        let values = [];


        let activeLayers = this.getLayerSource(activeLayer);

        let featureArray = activeLayers.getFeatures();

        if (featureArray.length >= 0) {
            featureArray.map((value, index) => {
                let valueProp = value.getProperties();  // feature içerisine setlediğimiz değerleri object olarak getirmektedir.

                delete valueProp["geometry"];  // Geometry alanı gereksiz olduğu için object array içerisinden kaldırılmıştır.

                let setValue = JSON.stringify(valueProp);

                let type = value.getGeometry().getType();

                let wkt = this.convertToWkt(value, 'EPSG:4326', 'EPSG:3857'); // içerisine aldığı geometry değerini string wkt ye dönüştürmektedir.

                obj = ({
                    workspaceId: parseFloat(workspaceId),
                    type: type,
                    wkt: wkt,
                    value: setValue
                });

                values.push(obj);
            })

            return values;
        }
    }

    static resetFeature = (feature) => {

        feature.set("name", "");
        feature.set("weight", 1);
        feature.set("fillColor", "#cfe0e7");
        feature.set("color", "#1e2e5d");
        feature.set("width", 3);
        feature.set("font", "arial");
        feature.set("stil", "normal");
        feature.set("size", "10");
        feature.set("fill", "#1e2e5d");
        feature.set("shading", false);
        feature.set("textBaseline", "middle");
        feature.set("placement", "point");
        feature.set("fillOpacity", 99);
        feature.set("fillStroke", "#1e2e5d");
        feature.set("textAlign", "center");
        feature.set("text", "normal");
        feature.set("rotation", 0);
        feature.set("circleFill", "#ff0000");
        feature.set("circleStroke", "#ffffff");
        feature.set("circleRadius", "10");
        feature.set("regularType", "circle");
        feature.set("fillOpacityPoint", "99");
        return feature;
    };

    zoomToWkt = (wkt, zoomLevel, projection, layer) => {

        const feature = convertToFeature(wkt, projection);

        this.zoomToFeature(feature, zoomLevel, layer)
    }

    zoomToFeature = (feature, zoomLevel, layer = "draw_layer") => {

        this.addFeature(layer, feature);

        this.viewLayerExtent(layer, feature, zoomLevel);
    }

    downloadImage = () => {

        let canvas = this.getMap().
            getTargetElement().
            firstElementChild.
            firstElementChild.
            firstElementChild.
            firstElementChild;

        let link = document.createElement('a'), e;

        link.download = "img";

        link.href = canvas.toDataURL('image/png;base64');

        if (document.createEvent) {

            e = document.createEvent('MouseEvents');

            e.initMouseEvent('click', true, true, window,
                0, 0, 0, 0, 0, false, false, false,
                false, 0, null);

            link.dispatchEvent(e);
        }
    }

    removeFeature = (layer, feature) => {

        const source = this.getLayerSource(layer);
        let featureId = feature.getId();
        let featuresTempList = source.getFeatures();

        for (let i = 0; i < featuresTempList.length; i++) {
            if (featuresTempList[i].getId() == featureId) {
                source.removeFeature(feature);
            }
        }

    }

    getBackgroundStyle = (props, data) => {

        let style = new Style({
            stroke: new Stroke({
                color: props.strokeColor || 'red',
                width: props.strokeWidth || 1,

            }),
            fill: new Fill({
                color: props.fillColor,
            }),
            text: new Text({
                text: (props.label && data[props.label]) ? data[props.label].toString() || "" : "",
                font: props.font,
                fill: new Fill({ color: props.strokeColor }),
                stroke: new Stroke({
                    color: props.strokeColor || "#000", width: 1
                })
            })
        });

        return style;
    }

    createCircle = (point, bufferValue) => {

        let _transformedGeom = this.transformGeometry(point, 'EPSG:3857', 'EPSG:4326');

        let pt = turf.geometry("Point", _transformedGeom.getCoordinates());

        let buffered = turf.buffer(pt, bufferValue, { units: 'meters' });

        let geom = new GeoJson().readFeature(buffered);

        let _geom2 = this.transformGeometry(geom.getGeometry(), 'EPSG:4326', 'EPSG:3857');

        return new Feature({
            geometry: _geom2
        });
    }

    transformGeometry = (geometry, sourceProjection, destinationProjection) => {
        if (!destinationProjection) {
            destinationProjection = OlDefault.olOptions.view.projection;
        }

        return geometry.transform(
            sourceProjection,
            destinationProjection
        );
    };

    setFeatureStyleIcon = (style) => {
        if (style) {
            if (style.isCircle) {
                return new Style({
                    image: new CircleStyle({
                        radius: 10,
                        fill: new Fill({
                            color: style.fillColor ? style.fillColor : 'rgba(255, 0, 0, 0.2)',
                        }),
                        stroke: new Stroke({
                            color: style.strokeColor ? style.strokeColor : '#ff0000',
                            width: style.strokeWidth ? style.strokeWidth : 2,
                        }),
                    }),
                });
            }
            else if (style.src) {
                return new Style({
                    image: new Icon({
                        anchor: [0.5, 46],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'pixels',
                        src: style.src
                    }),
                });
            }
        }
    }

    unionFeatures = (features) => {
        let geometry = null;
        if (features.length >= 1) {
            for (var i = 0; i < features.length; i++) {
                let feature = features[i].clone();
                let polys = feature.getGeometry().getCoordinates();
                let newGeometry = null;
                if (feature.getGeometry().getType() === "MultiPolygon") {
                    for (var s = 0; s < polys.length; s++) {
                        newGeometry = this.transformGeometry(new Polygon(polys[s]), "EPSG:3857", "EPSG:4326").getCoordinates();
                        if (geometry == null) {
                            geometry = turf.polygon(newGeometry);
                        }
                        else {
                            geometry = turf.union(geometry, turf.polygon(newGeometry));
                        }
                    }
                }
                else {
                    newGeometry = this.transformGeometry(feature.getGeometry(), "EPSG:3857", "EPSG:4326").getCoordinates();
                    if (geometry == null) {
                        geometry = turf.polygon(newGeometry);
                    }
                    else {
                        geometry = turf.union(geometry, turf.polygon(newGeometry));
                    }
                }
            }
        }
        if (geometry.geometry.type === "MultiPolygon") {
            return new Feature({
                name: "MultiPolygon",
                geometry: new MultiPolygon(geometry.geometry.coordinates),
            });
        }
        else {
            return new Feature({
                name: "Polygon",
                geometry: new Polygon(geometry.geometry.coordinates),
            });
        }
    }

    removeAllWfsLayers = () => {
        let map = this.getMap();
        if (!map) return;

        map.getLayers().forEach(layer => {
            if (layer?.get('name') && layer?.get('name').includes('wfs-layer-')) {
                map.removeLayer(layer)
            }
        });
    }

    disableAllTools = () => {
        this.getMap().getInteractions().getArray()
            .filter(x =>
                x.get("name") &&
                !x.get("name").includes("Snap") &&
                !x.get("name").includes("snap")
            ).forEach((i) => {
                i.setActive(false);
            });
    };

    static fullScreenView = () => {
        const elem = document.body;
        if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
            if (elem.requestFullScreen) {
                elem.requestFullScreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullScreen) {
                elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }
}

let baseMaps = [
    {
        id: 'NONE',
        source: null
    },
    {
        id: 'OR',
        source: MapTool.createOsmSource({
            crossOrigin: 'Anonymous',
            url: 'https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
        })
    },
    {
        id: 'OP',
        source: MapTool.createOsmSource({
            crossOrigin: 'Anonymous',
            url: 'https://otile1-s.mqcdn.com/tiles/1.0.0/osm/{z}/{x}/{y}.png'
        })
    },
    {
        id: 'OSM',
        source: MapTool.createOsmSource({
            crossOrigin: 'Anonymous',
            url: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'
        })
    },
];
